import React from 'react';

const Credits = () => {
  return (
    <div className="full-page-wrapper" style={{
      background: 'linear-gradient(to left bottom, #777777, #1a1a1a)',
      minHeight: '100vh',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      paddingTop: '0px',
      width: '100%'
    }}>
      <div className="app-theme" style={{
        padding: 'var(--spacing-lg, 30px)',
        width: '100%',
        maxWidth: '800px',
        position: 'relative',
        top: 0,
        left: 0
      }}>
        <div className="credits" style={{ position: 'relative', top: 0, left: 0 }}>
          <h1>Open Source Credits</h1>

          <section className="credits__section">
            <p>
              We gratefully acknowledge the open source projects that make Bagpipe Blasphemy possible.
              Licenses are included in the project; some projects may impose NOTICE requirements. Data
              shown on the map is © OpenStreetMap contributors.
            </p>
          </section>

          <section className="credits__section">
            <h2>Libraries</h2>
            <ul>
              <li>VexFlow (MIT)</li>
              <li>Tesseract.js (Apache-2.0)</li>
              <li>@supabase/supabase-js (Apache-2.0)</li>
              <li>React, React DOM (MIT)</li>
              <li>Chart.js, react-chartjs-2 (MIT)</li>
              <li>midi-parser-js (MIT)</li>
              <li>pitchy (MIT)</li>
              <li>jwt-decode (MIT)</li>
              <li>netlify-identity-widget (ISC)</li>
              <li>@sentry/* (MIT)</li>
              <li>react-leaflet (MIT), Leaflet (BSD-2)</li>
              <li>hCaptcha widget (terms of service apply)</li>
            </ul>
          </section>

          <section className="credits__section">
            <h2>Map Data</h2>
            <p>
              Map tiles and data provided by OpenStreetMap contributors under the ODbL; attribution is shown in the map UI.
            </p>
          </section>

          <section className="credits__section">
            <h2>Copyright</h2>
            <p>All application code © 2025 Bagpipe Blasphemy unless otherwise noted.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Credits;


